import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/cha.png';
const _withScopeId = n => (_pushScopeId("data-v-9fc668ca"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 2,
  style: {
    "position": "fixed",
    "top": "0",
    "left": "0",
    "background": "rgba(0, 0, 0, 0.5)",
    "z-index": "2001"
  },
  class: "w h blackClass"
};
const _hoisted_2 = {
  style: {
    "position": "absolute",
    "top": "50%",
    "left": "50%",
    "transform": "translate(-50%, -50%)",
    "width": "90%",
    "background": "#fff",
    "border-radius": "20px",
    "padding-top": "40px",
    "box-sizing": "border-box"
  }
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {
    "width": "25px",
    "height": "25px"
  }
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row column-c row-c"
}, "留下您的联系方式", -1));
const _hoisted_6 = {
  style: {
    "padding": "30px 20px 0 20px"
  }
};
const _hoisted_7 = {
  style: {
    "position": "relative"
  }
};
const _hoisted_8 = {
  key: 3,
  class: "w h row column-c row-c",
  style: {
    "position": "fixed",
    "background": "rgba(0, 0, 0, 0.5)",
    "top": "0",
    "left": "0",
    "z-index": "1998"
  }
};
const _hoisted_9 = {
  class: "w",
  style: {
    "padding": "0 20px"
  }
};
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "row column-c",
  style: {
    "height": "50px",
    "background": "#fff",
    "border-radius": "0 0 10px 10px",
    "border-top": "1px solid #eee"
  }
};
const _hoisted_13 = {
  style: {
    "min-height": "100vh"
  }
};
const _hoisted_14 = {
  key: 1,
  class: "main-container",
  ref: "container"
};
const _hoisted_15 = {
  class: "assembly"
};
const _hoisted_16 = {
  class: "setw",
  ref: "picture",
  id: "scrollBottomId"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = ["id"];
const _hoisted_20 = {
  key: 5,
  class: "diaStyle"
};
const _hoisted_21 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_post_card = _resolveComponent("post-card");
  const _component_title_assembly = _resolveComponent("title-assembly");
  const _component_rich_assembly = _resolveComponent("rich-assembly");
  const _component_picture_assembly = _resolveComponent("picture-assembly");
  const _component_postCardComp = _resolveComponent("postCardComp");
  const _component_graph_assembly = _resolveComponent("graph-assembly");
  const _component_atlas_assembly = _resolveComponent("atlas-assembly");
  const _component_video_assembly = _resolveComponent("video-assembly");
  const _component_form_assembly = _resolveComponent("form-assembly");
  const _component_telephone_assembly = _resolveComponent("telephone-assembly");
  const _component_qrcode_assembly = _resolveComponent("qrcode-assembly");
  const _component_popup_picture = _resolveComponent("popup-picture");
  const _component_logic = _resolveComponent("logic");
  const _component_order_modular = _resolveComponent("order-modular");
  const _component_obtaining_customers_assembly = _resolveComponent("obtaining-customers-assembly");
  const _component_principalbly = _resolveComponent("principalbly");
  const _component_com_popup = _resolveComponent("com-popup");
  return _openBlock(), _createElementBlock("div", {
    class: "allwh",
    onTouchstart: _cache[12] || (_cache[12] = (...args) => $options.start && $options.start(...args)),
    onTouchend: _cache[13] || (_cache[13] = (...args) => $options.end && $options.end(...args)),
    onTouchcancel: _cache[14] || (_cache[14] = (...args) => $options.cancel && $options.cancel(...args)),
    style: {
      "background": "rgba(255, 255, 255, 0.8)"
    }
  }, [$data.isBlackShow ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "background": "rgba(0, 0, 0, 0)",
      "z-index": "1999"
    },
    class: "w h blackClass",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  })) : _createCommentVNode("", true), $data.isBlackShow ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {
      _ctx.name = '';
      _ctx.mobile = '';
      $data.isBlackInputShow = true;
    }, ["stop"])),
    style: {
      "position": "fixed",
      "z-index": "2000",
      "bottom": "150px",
      "left": "50%",
      "transform": "translateX(-50%)",
      "width": "240px",
      "height": "50px",
      "border-radius": "5px",
      "background": "#0087ff",
      "color": "#fff"
    },
    class: "row column-c row-c"
  }, " 转化按钮 ")) : _createCommentVNode("", true), $data.isBlackInputShow ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    style: {
      "position": "absolute",
      "width": "50px",
      "height": "50px",
      "right": "10px",
      "top": "10px"
    },
    class: "row column-c row-c",
    onClick: _cache[2] || (_cache[2] = _withModifiers($event => $data.isBlackInputShow = false, ["stop"]))
  }, _hoisted_4), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "姓名",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.name = $event)
  }, null, 512), [[_vModelText, _ctx.name]])]), _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "手机号",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.mobile = $event),
    onBlur: _cache[5] || (_cache[5] = (...args) => $options.mobileChange && $options.mobileChange(...args))
  }, null, 544), [[_vModelText, _ctx.mobile]]), _withDirectives(_createElementVNode("div", {
    style: {
      "font-size": "12px",
      "color": "red",
      "position": "absolute",
      "bottom": "-20px",
      "left": "0"
    }
  }, _toDisplayString($data.mobileText), 513), [[_vShow, $data.isMobileShow]])])]), _createElementVNode("div", {
    class: "row column-c row-c",
    style: {
      "height": "60px",
      "border-top": "1px solid #ccc"
    },
    onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => $options.save && $options.save(...args), ["stop"]))
  }, " 提交 ")])])) : _createCommentVNode("", true), $data.isGainStoreAddressModule ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: "row column-c row-c w",
    style: _normalizeStyle([{
      "height": "50px",
      "border-radius": "10px 10px 0 0"
    }, {
      background: $data.setting.autoPopup.bgColor
    }])
  }, [$data.setting.autoPopup.iconPicture !== '' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$data.setting.autoPopup.iconPicture.includes('static/img/') ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    style: {
      "width": "20px",
      "height": "20px",
      "margin-right": "10px",
      "border-radius": "5px"
    },
    src: require('@/assets/img/WeChatWhite.png'),
    alt: ""
  }, null, 8, _hoisted_10)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    style: {
      "width": "20px",
      "height": "20px",
      "margin-right": "10px",
      "border-radius": "5px"
    },
    src: $data.setting.autoPopup.iconPicture,
    alt: ""
  }, null, 8, _hoisted_11))], 64)) : _createCommentVNode("", true), _createElementVNode("div", {
    style: _normalizeStyle({
      color: $data.setting.autoPopup.textColor
    })
  }, _toDisplayString($data.setting.autoPopup.title || "获取门店地址"), 5)], 4), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "h cell row column-c row-c",
    style: {
      "color": "#8d8d8d"
    },
    onClick: _cache[7] || (_cache[7] = $event => $options.jumpObtainStoreInformation($data.setting.autoPopup, 'clone'))
  }, " 关闭 "), _createElementVNode("div", {
    class: "h cell row column-c row-c",
    style: {
      "color": "red",
      "border-left": "1px solid #eee"
    },
    onClick: _cache[8] || (_cache[8] = $event => $options.jumpObtainStoreInformation($data.setting.autoPopup, 'go'))
  }, _toDisplayString($data.setting.autoPopup.btnTitle || "前往"), 1)])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [$data.showPostCard ? (_openBlock(), _createBlock(_component_post_card, {
    key: 0,
    ref: "rostCardRef",
    onBack: _cache[9] || (_cache[9] = $event => $data.showPostCard = false),
    uid: $data.uid,
    tid: $data.tid,
    currentRow: $data.currentRow,
    onBlackShow: $options.blackShow
  }, null, 8, ["uid", "tid", "currentRow", "onBlackShow"])) : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [$data.isIframe ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "set",
    style: _normalizeStyle({
      'background-color': $data.setting.bgColor,
      opacity: $data.setting.opacty,
      backgroundImage: 'url(' + $data.setting.bgpicture + ')'
    })
  }, null, 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [$data.urls ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onTouchstart: _cache[10] || (_cache[10] = $event => $options.touchStart($event)),
    onTouchend: _cache[11] || (_cache[11] = (...args) => $options.touchend && $options.touchend(...args))
  }, [_createElementVNode("img", {
    src: $data.urls,
    class: "urlsP",
    alt: ""
  }, null, 8, _hoisted_17)], 32)) : _createCommentVNode("", true), !$data.urls ? (_openBlock(), _createElementBlock("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.contents, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      id: item.hrefid,
      key: index,
      class: "list"
    }, [item.text === '标题' ? (_openBlock(), _createBlock(_component_title_assembly, {
      key: 0,
      content: item.setStyle
    }, null, 8, ["content"])) : _createCommentVNode("", true), item.text === '富文本' ? (_openBlock(), _createBlock(_component_rich_assembly, {
      key: 1,
      content: item.setStyle
    }, null, 8, ["content"])) : _createCommentVNode("", true), item.text === '图片' ? (_openBlock(), _createBlock(_component_picture_assembly, {
      key: 2,
      hrefs: $data.contents,
      content: item.setStyle,
      onOpenWechat: $options.openWechat,
      onArousePop: $options.arousePop,
      onJumpKf: $options.jumpKf,
      onJumpCustomerAcquisition: $options.jumpCustomerAcquisition,
      onOpenLogic: $options.openLogic,
      tid: $data.tid,
      urlParams: $data.urlParams
    }, null, 8, ["hrefs", "content", "onOpenWechat", "onArousePop", "onJumpKf", "onJumpCustomerAcquisition", "onOpenLogic", "tid", "urlParams"])) : _createCommentVNode("", true), item.text === '名片' ? (_openBlock(), _createBlock(_component_postCardComp, {
      key: 3,
      content: item.setStyle,
      tid: $data.tid,
      uid: $data.uid,
      link_id: _ctx.link_id,
      onBlackShow: $options.blackShow
    }, null, 8, ["content", "tid", "uid", "link_id", "onBlackShow"])) : _createCommentVNode("", true), item.text === '组图' ? (_openBlock(), _createBlock(_component_graph_assembly, {
      key: 4,
      hrefs: $data.contents,
      content: item.setStyle,
      onOpenWechat: $options.openWechat,
      onArousePop: $options.arousePop
    }, null, 8, ["hrefs", "content", "onOpenWechat", "onArousePop"])) : _createCommentVNode("", true), item.text === '图集' ? (_openBlock(), _createBlock(_component_atlas_assembly, {
      key: 5,
      content: item.setStyle
    }, null, 8, ["content"])) : _createCommentVNode("", true), item.text === '视频' ? (_openBlock(), _createBlock(_component_video_assembly, {
      key: 6,
      content: item.setStyle
    }, null, 8, ["content"])) : _createCommentVNode("", true), item.text === '表单' ? (_openBlock(), _createBlock(_component_form_assembly, {
      key: 7,
      content: item.setStyle
    }, null, 8, ["content"])) : _createCommentVNode("", true), item.text === '电话' ? (_openBlock(), _createBlock(_component_telephone_assembly, {
      key: 8,
      content: item.setStyle
    }, null, 8, ["content"])) : _createCommentVNode("", true), item.text === '微信包' ? (_openBlock(), _createBlock(_component_qrcode_assembly, {
      key: 9,
      class: "qrcodeAssembly",
      ref_for: true,
      ref: "qrcodeAssemblys",
      index: index,
      source: $data.source,
      tid: $data.tid,
      "page-type": $data.pageType,
      content: item.setStyle,
      "model-type": $data.modelType,
      hide_long_time: $data.hide_long_time,
      onLongEnd: $options.longEnd,
      onUserwechatid: $options.userwechatid,
      onHandleCanvas: $options.handleCanvas
    }, null, 8, ["index", "source", "tid", "page-type", "content", "model-type", "hide_long_time", "onLongEnd", "onUserwechatid", "onHandleCanvas"])) : _createCommentVNode("", true), item.text === '悬浮图片' || item.text === '品牌logo' ? (_openBlock(), _createBlock(_component_popup_picture, {
      key: 10,
      tid: $data.tid,
      text: item.text,
      content: item.setStyle,
      onJumpKf: $options.jumpKf,
      onJumpCustomerAcquisition: $options.jumpCustomerAcquisition,
      onOpenWechat: $options.openWechat,
      ibrand_id: $data.ibrand_id,
      ibrand_img: $data.ibrand_img,
      onArousePop: $options.arousePop
    }, null, 8, ["tid", "text", "content", "onJumpKf", "onJumpCustomerAcquisition", "onOpenWechat", "ibrand_id", "ibrand_img", "onArousePop"])) : _createCommentVNode("", true), item.text === '逻辑问答' ? (_openBlock(), _createBlock(_component_logic, {
      key: 11,
      onScrollBottom: $options.scrollBottom,
      content: item.setStyle,
      onOpenWechat: $options.openWechat,
      onOpenUrlLink: $options.openUrlLink,
      onJumpCustomerAcquisition: $options.jumpCustomerAcquisition,
      linkUrl: $data.linkUrl,
      onJumpKf: $options.jumpKf,
      onLinkUrlDel: $options.linkUrlDel
    }, null, 8, ["onScrollBottom", "content", "onOpenWechat", "onOpenUrlLink", "onJumpCustomerAcquisition", "linkUrl", "onJumpKf", "onLinkUrlDel"])) : _createCommentVNode("", true), item.text === '订单' ? (_openBlock(), _createBlock(_component_order_modular, {
      key: 12,
      ref_for: true,
      ref: "orderModul",
      content: item.setStyle,
      "model-type": $data.modelType,
      tid: $data.tid,
      dia: $data.dia,
      onJumpKf: $options.jumpKf,
      onOpenWechat: $options.openWechat,
      onOpenUrlLink: $options.openUrlLink,
      onDiaChange: $options.diaChange,
      onPaymentDataUrlChange: $options.paymentDataUrlChange,
      onJumpCustomerAcquisition: $options.jumpCustomerAcquisition
    }, null, 8, ["content", "model-type", "tid", "dia", "onJumpKf", "onOpenWechat", "onOpenUrlLink", "onDiaChange", "onPaymentDataUrlChange", "onJumpCustomerAcquisition"])) : _createCommentVNode("", true), item.text === '获客助手' ? (_openBlock(), _createBlock(_component_obtaining_customers_assembly, {
      key: 13,
      ref_for: true,
      ref: "obtainingCustomersAssembly",
      onJumpCustomerAcquisition: $options.jumpCustomerAcquisition,
      content: item.setStyle
    }, null, 8, ["onJumpCustomerAcquisition", "content"])) : _createCommentVNode("", true)], 8, _hoisted_19);
  }), 128))])) : _createCommentVNode("", true)], 512)])], 512)), [[_vShow, $data.dia !== 3]])]), $data.principalObj && $data.principalObj.text === '主体' ? (_openBlock(), _createBlock(_component_principalbly, {
    key: 4,
    content: $data.principalObj.setStyle
  }, null, 8, ["content"])) : _createCommentVNode("", true), $data.dia == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [$data.paymentDataUrl ? (_openBlock(), _createElementBlock("iframe", {
    key: 0,
    src: $data.paymentDataUrl,
    frameborder: "0",
    width: "100%",
    height: "100%"
  }, "\n      ", 8, _hoisted_21)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_component_com_popup, {
    ref: "comPopup",
    tid: $data.tid,
    popcontent: $data.popcontent,
    popsetting: $data.popsetting,
    onCloseComPopup: $options.closeComPopup,
    onOpenWechat: $options.openWechat,
    onArousePop: $options.arousePop,
    onJumpKf: $options.jumpKf,
    onJumpCustomerAcquisition: $options.jumpCustomerAcquisition,
    onBlackShow: $options.blackShow
  }, null, 8, ["tid", "popcontent", "popsetting", "onCloseComPopup", "onOpenWechat", "onArousePop", "onJumpKf", "onJumpCustomerAcquisition", "onBlackShow"])], 32);
}